module.exports = __webpack_public_path__ + "static/3-Swimming-Pool-16c31ffb6e46aa4128fb98f8b0b2c318.webp";